function o(a, t) {
  (t == null || t > a.length) && (t = a.length);
  for (var r = 0, f = new Array(t); r < t; r++)
    f[r] = a[r];
  return f;
}
export {
  o as default
};
//# sourceMappingURL=arrayLikeToArray.js.map
